import { Quark, HttpGet, Url, HttpResponse, HttpPost, HttpPut, JSONData } from 'sol-request-angular/dist/comunicacao';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { Infracao } from '@tivic-team/manager-ts/dist/mob';

@Injectable()
export class InfracaoController{

    constructor() { }

    async find(filtros?:IFilter):Promise<Array<Infracao>> {
        let quark = new Quark (
            new HttpGet({
                url: new Url({
                    id:'mob/infracoes',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<Infracao>()
            )
        );
        return await quark.call();
    }

    async get(cdInfracao: number):Promise<Infracao> {
        let quark = new Quark (
            new HttpGet ({
                url: new Url ({
                    id: 'mob/infracoes/:cdInfracao',
                    environment: environment,
                    pathParams: new JSONData({cdInfracao: cdInfracao})
                }),
            }),
            new HttpResponse (
                new Infracao()
            )
        );
        return await quark.call();
    }

    async create(infracao:Infracao):Promise<Infracao>{		
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'mob/infracoes',
					environment: environment
				}),
				data: new JSONData(infracao)
			}),
			new HttpResponse(
			  new Array<Infracao>()
			)
		);
		return await quark.call();
	}
	
	async update(infracao:Infracao):Promise<Infracao>{		
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'mob/infracoes/:cdInfracao',
					environment: environment,
					pathParams: new JSONData({cdInfracao: infracao.cdInfracao})
				}),
				data: new JSONData(infracao)
			}),
			new HttpResponse(
			  new Array<Infracao>()
			)
		);
		return await quark.call();
	}

}